<template>
  <div class='container-fluid'>
    <b-row>
      <b-nav class="admin-sub-nav" pills>
        <b-nav-item v-for="team in teams" :key="team.id" @click="getTeam(team.id)" :class="isActive(team.id)" action>
          {{ team.name }}
        </b-nav-item>
      </b-nav>
    </b-row>
    <b-row>
      <b-container v-if="team.id" fluid class="admin-sub-nav">
        <v-select v-model="collection" value="" :options="task_template_collections"></v-select>
        <b-button @click="newCollection = true; collection = null" variant="primary">Add New +</b-button>
      </b-container>
      <TaskTemplateCollection v-if="collection || newCollection" :collection="collection" :new_collection="newCollection"/>
    </b-row>
  </div>
</template>

<script>
import TaskTemplateCollection from './TaskTemplateCollection'
import { collectionsMixins } from '@/mixins/collectionsMixins'
export default {
  name: 'TaskTemplateCollections',
  mixins: [collectionsMixins],
  data () {
    return {
      task_template_collections: [],
      template_collections: [],
      collection: null,
      newCollection: false,
      team: {},
      active: ''
    }
  },
  computed: {
    teams () {
      return this.$store.getters.teams
    }
  },
  created () {
    this.$root.$on('templateCollectionUpdated', (data) => {
      this.templateCollections()
      this.collection = data
    })
    this.$root.$on('templateCollectionDeleted', () => {
      this.collection = null
      this.templateCollections()
    })
  },
  components: {
    TaskTemplateCollection
  },
  methods: {
    isActive (name) {
      return this.active === name ? 'active' : 'inactive'
    },
    makeActive (name) {
      this.active = name
    },
    getTeam (team) {
      var t = this.teams.find(function (t) {
        return t.id === team
      })
      this.team = t
      this.makeActive(team)
      this.collection = null
      this.newCollection = false
      this.allCollections()
    },
    allCollections () {
      var vm = this
      this.$http
        .get('/task_template_collections')
        .then(function (response) {
          vm.task_template_collections = response.data.map(function (collection) {
            return { label: collection.name, value: collection.id, team: collection.team_id }
          }).filter(vm.filterCollections)
        })
    },
    filterCollections (collection) {
      return collection.team === this.team.id
    }
  },
  watch: {
    collection: function () {
      if (this.collection) {
        this.newCollection = false
      }
    }
  }
}
</script>

<style scoped>
  .admin-sub-nav {
    display: inline-flex;
  }
  .custom-select {
    margin-right: 10px;
  }
  .v-select {
    margin-right: 10px;
    min-width: 50%;
  }
  li.nav-item.active, .nav-item.active a {
    color: #fff;
    background-color: #007bff;
    border-radius: .25rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/TaskTemplateCollections.vue